import { withStyles } from '@material-ui/core';

import Modal from './component';
import styles from './styles';

export default withStyles(styles)(Modal);
